function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VerificationCode } from '@arco-design/web-react';
import { I18nConsumer } from '@wegic/i18n-core';
import { Button, Message } from '@wegic/ui';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import IconRefresh from '@/assets/icons/Refresh.svg?react';
import { EMAIL_CODE_ERROR, MIN_REQ_EXCEEDS_LIMIT, VERIFY_CODE_EXPIRE } from '@/const/code';
import { useCountDown } from '@/hooks/useCountDown';
import { getUserInfo, registerByEmail, sendEmailVerifyCode } from '@/services';
import { buildAuthParamsWithAnonymous } from '@/utils';
import { LOGIN_I18N_NAMESPACE, loginI18nLoaders } from '../../i18n/loaders';
import styles from './index.module.less';
/** 组件级超时，避免弱网或服务端挂起时永久停在 submitting */ var VERIFY_TIMEOUT = 15000;
/** 请求进行中或已成功时，输入与提交都必须锁定 */ function isVerifyLocked(status) {
    return status === 'submitting' || status === 'success';
}
function readRegisterSessionPayload() {
    try {
        var raw = sessionStorage.getItem('register');
        if (!raw) {
            return null;
        }
        var parsed = JSON.parse(raw);
        if (!(parsed === null || parsed === void 0 ? void 0 : parsed.email)) {
            return null;
        }
        return {
            email: parsed.email,
            password: parsed.password || ''
        };
    } catch (unused) {
        return null;
    }
}
function EmailVerifyContent(props) {
    var onLockChange = props.onLockChange;
    var _ref = props.config || {}, getAnonymousId = _ref.getAnonymousId, onEvent = _ref.onEvent;
    var _useState = _sliced_to_array(useState('idle'), 2), verifyStatus = _useState[0], setVerifyStatus = _useState[1];
    var _useState1 = _sliced_to_array(useState(''), 2), codeErrorMessage = _useState1[0], setCodeErrorMessage = _useState1[1];
    var _useState2 = _sliced_to_array(useState(''), 2), targetCode = _useState2[0], setTargetCode = _useState2[1];
    var _useState3 = _sliced_to_array(useState(true), 2), autoSend = _useState3[0], setAutoSend = _useState3[1];
    var _useCountDown = useCountDown(), restTime = _useCountDown.restTime, setRestTime = _useCountDown.setRestTime;
    // register session 由上一步注册流程写入；缺失时说明用户刷新或直接进入了验证页，需要走错误兜底。
    var register = readRegisterSessionPayload();
    var containerRef = useRef(null);
    // state 更新是异步的，自动提交与按钮点击可能落在同一帧，用 ref 同步挡住并发提交。
    var verifyStatusRef = useRef('idle');
    var isMountedRef = useRef(false);
    useEffect(function() {
        isMountedRef.current = true;
        onLockChange === null || onLockChange === void 0 ? void 0 : onLockChange(isVerifyLocked(verifyStatusRef.current));
        return function() {
            isMountedRef.current = false;
            onLockChange === null || onLockChange === void 0 ? void 0 : onLockChange(false);
        };
    }, [
        onLockChange
    ]);
    var applyVerifyStatus = function(status) {
        verifyStatusRef.current = status;
        setVerifyStatus(status);
        if (isMountedRef.current) {
            onLockChange === null || onLockChange === void 0 ? void 0 : onLockChange(isVerifyLocked(status));
        }
    };
    var handleResendCode = function() {
        return _async_to_generator(function() {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!register) {
                            return [
                                2
                            ];
                        }
                        setRestTime(59);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            sendEmailVerifyCode(register.email, 'register')
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        if ((e === null || e === void 0 ? void 0 : e.code) !== MIN_REQ_EXCEEDS_LIMIT) {
                            setRestTime(0);
                        }
                        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                            type: 'error',
                            error: {
                                message: (e === null || e === void 0 ? void 0 : e.message) || intl.get('Send_Code_Failed'),
                                type: 'network'
                            },
                            source: 'verify-code'
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setAutoSend(false);
                        return [
                            7
                        ];
                    case 5:
                        // 重发后旧验证码作废：清空输入与旧错误，回到可输入状态。
                        setTargetCode('');
                        setCodeErrorMessage('');
                        applyVerifyStatus('idle');
                        return [
                            2
                        ];
                }
            });
        })();
    };
    useEffect(function() {
        var _containerRef_current_querySelector, _containerRef_current;
        if (!register) {
            onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                type: 'error',
                error: {
                    message: 'Missing register session payload',
                    type: 'auth'
                },
                source: 'register'
            });
            setAutoSend(false);
            return;
        }
        (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : (_containerRef_current_querySelector = _containerRef_current.querySelector('input')) === null || _containerRef_current_querySelector === void 0 ? void 0 : _containerRef_current_querySelector.focus();
        // 自动发送验证码失败不向外抛出，避免 useEffect 产生未处理的 Promise rejection。
        void handleResendCode();
    }, []);
    if (!register) {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles['email-verify'],
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.title,
                    children: intl.get('Register_Form_Title')
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.description,
                    children: intl.get('Login_Failed_Message')
                })
            ]
        });
    }
    var handleSubmit = function(verificationCode) {
        return _async_to_generator(function() {
            var currentStatus, params, code, data, e, isNetworkError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentStatus = verifyStatusRef.current;
                        // 只允许从可输入状态或可重试状态发起，且验证码必须已满 6 位。
                        if (currentStatus !== 'idle' && currentStatus !== 'retryable' || !/^\d{6}$/.test(verificationCode)) {
                            return [
                                2
                            ];
                        }
                        applyVerifyStatus('submitting');
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        params = buildAuthParamsWithAnonymous({
                            email: register.email,
                            password: register.password,
                            code: verificationCode
                        }, getAnonymousId);
                        return [
                            4,
                            registerByEmail(params, {
                                allowedCodes: [
                                    EMAIL_CODE_ERROR,
                                    VERIFY_CODE_EXPIRE
                                ],
                                timeout: VERIFY_TIMEOUT
                            })
                        ];
                    case 2:
                        code = _state.sent().code;
                        if (!(code === 0)) return [
                            3,
                            5
                        ];
                        // 注册已成功：锁定直到弹窗关闭，后续收尾异常也不能让状态回退。
                        applyVerifyStatus('success');
                        Message.success(intl.get('Register_Success_Message'));
                        return [
                            4,
                            getUserInfo()
                        ];
                    case 3:
                        data = _state.sent().data;
                        return [
                            4,
                            onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                                type: 'register:success',
                                data: data
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (code === EMAIL_CODE_ERROR || code === VERIFY_CODE_EXPIRE) {
                            // 验证码本身不可用：清空输入让用户重填，不提供确认按钮。
                            setTargetCode('');
                            setCodeErrorMessage(code === VERIFY_CODE_EXPIRE ? intl.get('ForgetPassword_Form_CodeExpire') : intl.get('Register_Form_CodeErrorTips'));
                            applyVerifyStatus('invalid');
                        } else {
                            // 其余业务错误（含未注册、用户名已存在等）无法判定验证码本身：交给用户手动重试。
                            applyVerifyStatus('retryable');
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        // 未在 allowedCodes 内的业务错误、HTTP 5xx、网络断开与超时都会走到这里。
                        // 请求层把网络异常与超时统一归一化为 code -1，无法再细分，因此一并归入可重试。
                        isNetworkError = !(e === null || e === void 0 ? void 0 : e.status) && (e === null || e === void 0 ? void 0 : e.code) === -1;
                        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                            type: 'error',
                            error: {
                                message: (e === null || e === void 0 ? void 0 : e.message) || intl.get('Register_Failed_Message'),
                                type: isNetworkError ? 'network' : 'auth'
                            },
                            source: 'register'
                        });
                        return [
                            3,
                            9
                        ];
                    case 8:
                        // 网络异常、超时、5xx 都只走到这里：释放请求锁并开放手动重试；成功时保持锁定。
                        if (verifyStatusRef.current === 'submitting') {
                            applyVerifyStatus('retryable');
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var handleTargetCodeChange = function(value) {
        if (isVerifyLocked(verifyStatusRef.current)) {
            return;
        }
        if (verifyStatusRef.current === 'invalid') {
            // 用户重新输入：清掉旧的验证码错误，恢复正常校验。
            setCodeErrorMessage('');
            applyVerifyStatus('idle');
        }
        // 过滤非数字字符
        var chars = value.split('');
        var validValue = chars.filter(function(word) {
            return /\d/.test(word);
        }).join('').slice(0, 6);
        setTargetCode(validValue);
        if (validValue.length === 6) {
            void handleSubmit(validValue);
        }
    };
    var isLocked = isVerifyLocked(verifyStatus);
    var isRetryable = verifyStatus === 'retryable';
    var isInvalid = verifyStatus === 'invalid';
    var _obj;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles['email-verify'],
        ref: containerRef,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.title,
                children: intl.get('Register_Form_Title')
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.description,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: intl.get('Register_Form_SendEmail')
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: register.email
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: intl.get('Register_Form_ConfirmTips')
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(VerificationCode, {
                size: "large",
                className: classNames((_obj = {}, _define_property(_obj, styles.code, true), _define_property(_obj, styles['code-error'], isInvalid), _obj)),
                value: targetCode,
                disabled: isLocked,
                onChange: handleTargetCodeChange
            }),
            isInvalid && /*#__PURE__*/ _jsx("div", {
                className: styles['error-message'],
                children: codeErrorMessage
            }),
            /*#__PURE__*/ _jsx(Button, {
                type: "secondary",
                className: styles.resend,
                icon: /*#__PURE__*/ _jsx(IconRefresh, {}),
                onClick: handleResendCode,
                loading: isLocked,
                disabled: !!restTime || autoSend,
                children: restTime ? "".concat(restTime, "s") : intl.get('Register_Form_Resend')
            }),
            isRetryable && /*#__PURE__*/ _jsx(Button, {
                block: true,
                onClick: function() {
                    return void handleSubmit(targetCode);
                },
                disabled: targetCode.length < 6,
                className: styles['verify-button'],
                children: /*#__PURE__*/ _jsx("span", {
                    children: intl.get('Register_Form_ButtonText')
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles['spam-tips'],
                children: intl.get('Register_Form_SpamTips')
            })
        ]
    });
}
function EmailVerify(props) {
    return /*#__PURE__*/ _jsx(I18nConsumer, {
        loaders: loginI18nLoaders,
        namespace: LOGIN_I18N_NAMESPACE,
        children: /*#__PURE__*/ _jsx(EmailVerifyContent, _object_spread({}, props))
    });
}
export default EmailVerify;
